<template>
  <div class="card modal-card-border infoWindowMap">
    <div class="card-content">
      <div :key="index" v-for="(reseau, index) in marker.reseaux"
           v-if="index === marker.indexReseauCourant" >
        <div>
          <div class="columns">
            <div class="column is-1">
              <a  @click="precedent()"
                  v-bind:class="{disabled: !peutAllerPrecedent() }">
                <b-icon icon="chevron-left" class="arrow" size="is-large"></b-icon>
              </a>
            </div>
            <div class="column">
              <div class="information-title">
                <h2 class="subtitle is-5">
                  {{marker.reseaux.length}} réseau(x)
                </h2>
                <h1 class="title is-6">{{reseau.libelle}}</h1>
              </div>
              <div class="detail-component">
                <br>
                <h1 class="subtitle is-6 information-title">Informations</h1>
                <div class="columns">
                  <div class="column is-4">
                    <p class="information">Code réseau</p>
                    <span>{{reseau.code}}</span>
                  </div>
                  <div class="column is-4">
                    <p class="information">Nombre de faces</p>
                    <span>{{reseau.nbFaces}}</span>
                  </div>
                  <div class="column is-4">
                    <p class="information">Tarif brut</p>
                    <span>{{reseau.tarifBrut}}</span>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-4">
                    <p class="information">Ville</p>
                    <span>{{reseau.ville}}</span>
                  </div>
                  <div class="column is-4">
                    <p class="information" v-if="reseau.format">Format</p>
                    <span v-if="reseau.format">{{reseau.format}}</span>
                  </div>
                  <div class="column is-4">
                    <p class="information">Jour de départ</p>
                    <span>{{reseau.jourDepart}}</span>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-4">
                    <p class="information">Délai de conservation</p>
                    <span>{{reseau.dureeConservation}} </span>
                  </div>
                  <div class="column is-4">
                    <p class="information" v-if="reseau.confrere">Confrère</p>
                    <span v-if="reseau.confrere">{{reseau.confrere}}</span>
                  </div>
                  <div class="column is-4">
                  </div>
                </div>
              </div>
              <div>
                <button v-if="!reseau.selected"
                        class="button is-primary button-modal-detail"
                        @click="ajoutPanier(reseau)">
                  <b-icon icon="cart-plus"></b-icon><p>Ajouter au panier</p>
                </button>
                <button v-else
                        class="button is-danger button-modal-detail"
                        @click="ajoutPanier(reseau)">
                  <b-icon icon="cart-off"></b-icon><p>Retirer du panier</p>
                </button>
                <button class="button is-primary button-modal-detail"
                        @click="zoomReseau(marker)">
                  <b-icon icon="magnify-plus"></b-icon><p>Zoom</p>
                </button>
                <button class="button is-primary button-modal-detail"
                        @click="ouvrirDiaporama(reseau)">
                  <b-icon icon="image-multiple"></b-icon><p>Diaporama</p>
                </button>
              </div>
            </div>
            <div class="column is-1">
              <a  @click="suivant()"
                  v-bind:class="{disabled: !peutAllerSuivant() }">
                <b-icon icon="chevron-right" class="arrow" size="is-large"></b-icon>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as typesModal from '@/store/creationOpportunite/modal-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';

const VenteReseauxLc = createNamespacedHelpers('venteReseauxLc');
const Modal = createNamespacedHelpers('modal');

export default {
  name: 'info-window-map',
  props: ['marker', 'centre'],
  data() {
    return {
      infoAffiche: false,
    };
  },
  computed: {
    ...VenteReseauxLc.mapGetters({
      reseauxLcWithFilter: 'reseauxLcWithFilter',
    }),
    ...Modal.mapGetters({
      getIsComponentDiaporama: 'isComponentDiaporama',
      getFacesDiapoSelect: 'facesSelectDiapo',
    }),
    facesReseauSelectDiapo: {
      get() {
        return this.getFacesReseauSelect;
      },
      set(value) {
        this.setFacesReseauSelect(value);
      },
    },
    isComponentDiaporama: {
      get() {
        return this.getIsComponentDiaporama;
      },
      set(value) {
        this.setIsComponentDiaporama(value);
      },
    },
  },
  watch: {
    marker() {
      this.infoAffiche = false;
      if (!this.marker) {
        return;
      }
      if (this.marker) {
        this.infoAffiche = true;
      }
    },
  },
  methods: {
    ...VenteReseauxLc.mapActions({
      actionsGestionPanier: 'gestionPanier',
      actionsPeutAjouterAuPanier: 'peutAjouterAuPanier',
    }),
    ...Modal.mapMutations({
      setIsComponentDiaporama: typesModal.SET_IS_COMPONENT_DIAPORAMA,
      setFacesReseauSelect: typesModal.SET_FACES_SELECT_DIAPO,
    }),
    cloture() {
      this.$emit('closeInfoWindow');
    },
    precedent() {
      if (this.peutAllerPrecedent()) {
        this.marker.indexReseauCourant = this.marker.indexReseauCourant - 1;
      }
    },
    suivant() {
      if (this.peutAllerSuivant()) {
        this.marker.indexReseauCourant = this.marker.indexReseauCourant + 1;
      }
    },
    peutAllerPrecedent() {
      return this.marker.indexReseauCourant !== 0;
    },
    peutAllerSuivant() {
      return this.marker.indexReseauCourant + 1 < this.marker.reseaux.length;
    },
    zoomReseau() {
      this.$parent.close();
      this.$emit('zoomReseau');
    },
    ajoutPanier(reseau) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      if (!this.actionsPeutAjouterAuPanier) {
        return;
      }
      reseau.selected = !reseau.selected;
      this.actionsGestionPanier(reseau.num).then(() => {
        loadingComponent.close();
      }).catch((e) => {
        gestionErreur(`Erreur de l'ajout au panier du reseau LC n°${reseau.num}`, e);
        loadingComponent.close();
        throw (e);
      });
    },
    ouvrirDiaporama(reseau) {
      const newReseau = this.reseauxLcWithFilter.find((el) => {
        return el.num === reseau.num;
      });
      newReseau.listeFaces.forEach((el) => {
        el.libelleReseau = reseau.libelle;
      });
      this.facesReseauSelectDiapo = newReseau.listeFaces;
      this.isComponentDiaporama = true;
    },
  },
};
</script>

<style scoped>
  .columns{
    margin:0px;
  }

  .mdi-chevron-right, .mdi-chevron-left{
    margin-left : 0px;
    margin-right : 0px;
    margin-top : 50px;
  }

  .button-card {
    margin-right: 5px;
  }

  .information {
    font-size:14px;
  }

  .information-title {
    margin-left:10px;
    margin-bottom:0;
  }

  .arrow {
    height: 30vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxLc/recherche/cartographie/infoWindowMapReseaux.vue